<template>
    <v-row justify="center" align-content="center" style="margin-bottom:10px">
        <v-col cols="auto">
           　<v-tooltip bottom v-model="show1">
              <template v-slot:activator="{ on, attrs }">
                <v-badge bordered color="grey darken-1" content="?" overlap v-on:mouseover.native="show1 = true" v-on:mouseleave.native="show1 = false">
                    <div class="addWapper" :style="textStyle">
                        <v-btn block color="orange" class="addBtn white--text addBtn" v-on:click="addText" >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-text-field class="addText" value=" " label="テキストボックス" outlined hide-details disabled style="font-size: 1.5rem !important;"></v-text-field>
                    </div>
                </v-badge>
              </template>
              <span>テキスト　の活用方法
                    <br>・「住所」や「会社名」等の契約情報を書面へ入力する場合
                    <br>・成果物や対象物など契約対象を入力する場合
              </span>
            </v-tooltip>
        </v-col>
        <v-col cols="auto">
           　<v-tooltip bottom v-model="show4">
              <template v-slot:activator="{ on, attrs }">
                <v-badge bordered color="grey darken-1" content="?" overlap v-on:mouseover.native="show4 = true" v-on:mouseleave.native="show4 = false">
                    <div class="addWapper" :style="selectStyle">
                        <v-btn block color="orange" class="addBtn white--text addBtn" v-on:click="addSelect" >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-select class="addSelect" label="セレクトボックス" outlined hide-details disabled style="font-size: 1.5rem !important;"></v-select>
                    </div>
                </v-badge>
              </template>
              <span>セレクトボックス　の活用方法
                    <br>入力内容を所定の選択肢から選んでいただく際にご利用ください。
                    <br>・取引基本契約書での、支払条件や支払期日の選択
                    <br>・サービス利用申込書での、対象サービスやプランの選択
                    <br>等でご活用いただいております。
              </span>
            </v-tooltip>
        </v-col>
        <v-col cols="auto">
           　<v-tooltip bottom v-model="show2">
              <template v-slot:activator="{ on, attrs }">
                <v-badge bordered color="grey darken-1" content="?" overlap v-on:mouseover.native="show2 = true" v-on:mouseleave.native="show2 = false">

                    <div class="addWapper">
                        <v-btn block color="orange" class="addBtn white--text" v-on:click="addCheckbox" >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <div class="checkbox-icon">
                            <input type="checkbox" checked disabled>
                            <label>{{ checkboxText }}</label>
                        </div>
                    </div>
                </v-badge>
              </template>
              <span>チェックボックス　の活用方法
                    <br>・「プラン」や「オプション」などの申込内容をかんたんに選択できるようにする場合
                    <br>・「上記全ての規約を読み、内容を理解しました。」などの文言にチェックを必須とし、相手方が確実に読んだことを確認する場合
              </span>
            </v-tooltip>
        </v-col>
        <v-col cols="auto">
           　<v-tooltip bottom v-model="show3">
              <template v-slot:activator="{ on, attrs }">
                <v-badge bordered color="grey darken-1" content="?" overlap v-on:mouseover.native="show3 = true" v-on:mouseleave.native="show3 = false">
                    <div class="addWapper" :style="sealStyle">
                        <v-btn block color="orange" class="addBtn white--text" v-on:click="addSeal" >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <span class="circle"><span class="addSeal">印影</span></span>
                    </div>
                </v-badge>
              </template>
              <span>印影　の活用方法
                    <br>・擬似的な印影を生成し、押印することができます。
                    <br>・会社名やお名前でご利用いただけます。
              </span>
            </v-tooltip>
        </v-col>
        <v-col cols="auto" v-if="templateInputShow">
            <div class="addInput">
           　<v-btn class="white--text" color="orange" @click="templateInput">入力項目をインポート</v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: ['templateInputShow'],
        data: function () {
            return {
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                textStyle: { width: '255px' },
                selectStyle: { width: '255px' },
                sealStyle: {},
                checkboxText: "チェックボックス",
            };
        },
        created() {
            if(this.templateInputShow){
                this.textStyle = { width: '180px' }
                this.selectStyle = { width: '220px' }
                this.sealStyle = { width: '110px' }
                this.checkboxText = ""
            }
        },
        methods: {
            addText: function () {
                this.$emit('addText');
            },
            addSelect: function () {
                this.$emit('addSelect');
            },
            addCheckbox: function () {
                this.$emit('addCheckbox');
            },
            addSeal: function () {
                this.$emit('addSeal');
            },
            // テンプレートから入力項目をインポート
            templateInput: function () {
                this.$emit('templateInput', true);
            },
        }
    };
</script>

<style scoped>
    ::v-deep .v-label {
        font-size: 1.5rem !important; 
        color: #AAA !important;
    }
    ::v-deep .v-badge--bordered .v-badge__badge:after {
        border-width: 0px;
    }
    .addWapper {
        display: flex;
        border: 1px solid #AAA;
        padding: 10px;
        vertical-align: middle;
        background: white;
        border-radius: 5px;
        height: 78px !important;
        white-space: nowrap;
    }
    .addInput {
        padding: 10px 0;
    }
    .addBtn {
        width: 32px !important;
        min-width: 32px !important;
        max-width: 32px !important;
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        margin: auto 0;
    }
    .addText,.addSelect {
        margin-left: 5px;
    }
    .addText > .v-input__control > .v-text-field__details {
        display: none;
    }
    .addSeal {
        -ms-writing-mode: tb-rl;
        writing-mode: vertical-rl;
        padding-top: 5px;
        margin-left: -3px;
        font-size: 1.2rem;
        color: #AAA;
    }
    .circle {
        display: inline-block;
        width: 40px;
        height: 40px;
        text-align:center;
        line-height: 40px;
        border-radius: 50%;
        border: solid 3px #AAA;
        margin: auto 30px auto 6px;
    }
    .checkbox-icon {
        margin: auto;
    }
    /* 元々のチェックボックス（非表示） */
    .checkbox-icon input[type="checkbox"]{
        display: none;
    }
    /* チェックボックスの代わりを成すラベル */
    .checkbox-icon input[type="checkbox"]+label{
        color: #AAA !important;
        font-size: 1.5rem !important;
        display: inline-block;
        position: relative;
        padding-left: 25px;
        padding-right: 10px;
        margin-left: 5px;
    }
    /* ラベルの左に表示させる正方形のボックス□ */
    .checkbox-icon input[type="checkbox"]+label::before{
        color: #AAA !important;
        content: "";
        position: absolute;
        display: block;
        box-sizing: border-box;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        left: 0;
        top: 50%;
        border: 1px solid;
        border-color:  #AAA; /* 枠の色 */
        background-color: #FFF; /* 背景 */
    }
    /* チェックが入った時のレ点 */
    .checkbox-icon input[type="checkbox"]:checked+label::after{
        content: "";
        position: absolute;
        display: block;
        box-sizing: border-box;
        width: 18px;
        height: 10px;
        margin-top: -10px;
        top: 50%;
        left: 5px;
        transform: rotate(-45deg);
        border-bottom: 3px solid;
        border-left: 3px solid;
        border-color:  #AAA; /* チェックの色 */
    }
    
    .col{
        padding:8px !important;
    }
</style>
